/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ProfileSetEntry from './ProfileSetEntry';

/**
 * The InlineResponse2004 model module.
 * @module model/InlineResponse2004
 * @version 1.0
 */
class InlineResponse2004 {
    /**
     * Constructs a new <code>InlineResponse2004</code>.
     * @alias module:model/InlineResponse2004
     */
    constructor() { 
        
        InlineResponse2004.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2004</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2004} obj Optional instance to populate.
     * @return {module:model/InlineResponse2004} The populated <code>InlineResponse2004</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2004();

            if (data.hasOwnProperty('ACADEMIC')) {
                obj['ACADEMIC'] = ProfileSetEntry.constructFromObject(data['ACADEMIC']);
            }
            if (data.hasOwnProperty('PROMO')) {
                obj['PROMO'] = ProfileSetEntry.constructFromObject(data['PROMO']);
            }
            if (data.hasOwnProperty('JOB')) {
                obj['JOB'] = ProfileSetEntry.constructFromObject(data['JOB']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/ProfileSetEntry} ACADEMIC
 */
InlineResponse2004.prototype['ACADEMIC'] = undefined;

/**
 * @member {module:model/ProfileSetEntry} PROMO
 */
InlineResponse2004.prototype['PROMO'] = undefined;

/**
 * @member {module:model/ProfileSetEntry} JOB
 */
InlineResponse2004.prototype['JOB'] = undefined;






export default InlineResponse2004;

